/*
    Quick Reply
*/

// Show Hover State
var showHover = document.getElementById('show-hover-quick-reply');
showHover.addEventListener('click', function() {
    var hoverQuickReply = document.getElementById('hover-quick-reply');
    hoverQuickReply.classList.add("show");
    var buttonQuickReply = document.getElementById('button-hover-quick-reply');
    buttonQuickReply.classList.add("hide");

    // Copy Settings to Hover
    copySettingsToHover();
});

function copySettingsToHover() {
    window.customStyle[".MessengerQuickReply:hover"]['background'] = window.customStyle[".MessengerQuickReply"]['background'];
    window.customStyle[".MessengerQuickReply:hover"]['color'] = window.customStyle[".MessengerQuickReply"]['color'];
    window.customStyle[".MessengerQuickReply:hover"]['border-top-left-radius'] = window.customStyle[".MessengerQuickReply"]['border-top-left-radius'];
    window.customStyle[".MessengerQuickReply:hover"]['border-top-right-radius'] = window.customStyle[".MessengerQuickReply"]['border-top-right-radius'];
    window.customStyle[".MessengerQuickReply:hover"]['border-bottom-right-radius'] = window.customStyle[".MessengerQuickReply"]['border-bottom-right-radius'];
    window.customStyle[".MessengerQuickReply:hover"]['border-bottom-left-radius'] = window.customStyle[".MessengerQuickReply"]['border-bottom-left-radius'];
    window.customStyle[".MessengerQuickReply:hover"]['padding-top'] = window.customStyle[".MessengerQuickReply"]['padding-top'];
    window.customStyle[".MessengerQuickReply:hover"]['padding-bottom'] = window.customStyle[".MessengerQuickReply"]['padding-bottom'];
    window.customStyle[".MessengerQuickReply:hover"]['padding-left'] = window.customStyle[".MessengerQuickReply"]['padding-left'];
    window.customStyle[".MessengerQuickReply:hover"]['padding-right'] = window.customStyle[".MessengerQuickReply"]['padding-right'];
    window.customStyle[".MessengerQuickReply:hover"]['margin-top'] = window.customStyle[".MessengerQuickReply"]['margin-top'];
    window.customStyle[".MessengerQuickReply:hover"]['margin-bottom'] = window.customStyle[".MessengerQuickReply"]['margin-bottom'];
    window.customStyle[".MessengerQuickReply:hover"]['margin-left'] = window.customStyle[".MessengerQuickReply"]['margin-left'];
    window.customStyle[".MessengerQuickReply:hover"]['margin-right'] = window.customStyle[".MessengerQuickReply"]['margin-right'];
    window.customStyle[".MessengerQuickReply:hover"]['box-sizing'] = window.customStyle[".MessengerQuickReply"]['box-sizing'];
    window.customStyle[".MessengerQuickReply:hover"]['border'] = window.customStyle[".MessengerQuickReply"]['border'];
    window.customStyle[".MessengerQuickReply:hover"]['box-shadow'] = window.customStyle[".MessengerQuickReply"]['box-shadow'];
    window.customStyle[".MessengerQuickReply:hover"]['font-family'] = window.customStyle[".MessengerQuickReply"]['font-family'];
    window.customStyle[".MessengerQuickReply:hover"]['font-size'] = window.customStyle[".MessengerQuickReply"]['font-size'];
    window.styleElement.textContent = window.css.of(window.customStyle);

    // Copy Background color
    document.getElementById("quick-reply-color-selector-hover").value = document.getElementById("quick-reply-color-selector").value;
    document.getElementById("color-preview-quick-reply-hover").style.backgroundColor = document.getElementById("color-preview-quick-reply").style.backgroundColor;
    // Copy Text color
    document.getElementById("quick-reply-text-color-selector-hover").value = document.getElementById("quick-reply-text-color-selector").value;
    document.getElementById("color-preview-text-quick-reply-hover").style.backgroundColor = document.getElementById("color-preview-text-quick-reply").style.backgroundColor;
    // Copy Font style
    document.getElementById("quick-reply-hover-text-font-selector").value = document.getElementById("quick-reply-text-font-selector").value;
    document.getElementById("quick-reply-hover-text-font-selector").style.color = document.getElementById("quick-reply-text-font-selector").style.color;
    document.getElementById("quick-reply-hover-text-font-selector").style.fontFamily = document.getElementById("quick-reply-text-font-selector").style.fontFamily;
    document.getElementById("quick-reply-hover-text-font-selector").style.fontSize = document.getElementById("quick-reply-text-font-selector").style.fontSize;
    // Copy Corner Radius
    document.getElementById("corner-radius-topL-quick-reply-hover").value = document.getElementById("corner-radius-topL-quick-reply").value;
    document.getElementById("corner-radius-topR-quick-reply-hover").value = document.getElementById("corner-radius-topR-quick-reply").value;
    document.getElementById("corner-radius-bottomL-quick-reply-hover").value = document.getElementById("corner-radius-bottomL-quick-reply").value;
    document.getElementById("corner-radius-bottomR-quick-reply-hover").value = document.getElementById("corner-radius-bottomR-quick-reply").value;
    // Copy Padding
    document.getElementById("padding-top-quick-reply-hover").value = document.getElementById("padding-top-quick-reply").value;
    document.getElementById("padding-bottom-quick-reply-hover").value = document.getElementById("padding-bottom-quick-reply").value;
    document.getElementById("padding-left-quick-reply-hover").value = document.getElementById("padding-left-quick-reply").value;
    document.getElementById("padding-right-quick-reply-hover").value = document.getElementById("padding-right-quick-reply").value;
    // Copy Margin
    document.getElementById("margin-top-quick-reply-hover").value = document.getElementById("margin-top-quick-reply").value;
    document.getElementById("margin-bottom-quick-reply-hover").value = document.getElementById("margin-bottom-quick-reply").value;
    document.getElementById("margin-left-quick-reply-hover").value = document.getElementById("margin-left-quick-reply").value;
    document.getElementById("margin-right-quick-reply-hover").value = document.getElementById("margin-right-quick-reply").value;
    // Copy Border
    borderColorHover = borderColor;
    borderWidthHover = borderWidth
    borderStringHover = borderString;
    document.getElementById("quick-reply-border-selector-hover").value = document.getElementById("quick-reply-border-selector").value;
    document.getElementById("quick-reply-hover-border-color-selector").value = document.getElementById("quick-reply-border-color-selector").value;
    document.getElementById("color-border-preview-quick-reply-hover").style.backgroundColor = document.getElementById("color-border-preview-quick-reply").style.backgroundColor;
    document.getElementById("width-border-quick-reply-hover").value = document.getElementById("width-border-quick-reply").value;
    // Copy Shadow
    hOffsetHover = hOffset;
    vOffsetHover = vOffset;
    blurShadowHover = blurShadow;
    spreedHover = spreed;
    shadowColorHover = shadowColor;
    shadowPosHover = shadowPos;
    document.getElementById("quick-reply-shadow-h-offset-hover").value = document.getElementById("quick-reply-shadow-h-offset").value;
    document.getElementById("quick-reply-shadow-v-offset-hover").value = document.getElementById("quick-reply-shadow-v-offset").value;
    document.getElementById("quick-reply-shadow-blur-hover").value = document.getElementById("quick-reply-shadow-blur").value;
    document.getElementById("quick-reply-shadow-spreed-hover").value = document.getElementById("quick-reply-shadow-spreed").value;
    document.getElementById("quick-reply-shadow-color-selector-hover").value = document.getElementById("quick-reply-shadow-color-selector").value;
    document.getElementById("color-shadow-preview-color-quick-reply-hover").style.backgroundColor = document.getElementById("color-shadow-preview-color-quick-reply").style.backgroundColor;
    document.getElementById("quick-reply-shadow-position-hover").value = document.getElementById("quick-reply-shadow-position").value;
}


// Quick Reply Background Color
var select = document.getElementById('quick-reply-color-selector');
var colorPreview = document.getElementById('color-preview-quick-reply');
window.updateQuickReplyColor = function() {
    select.replaceChildren();
    var option = document.createElement('option');
    option.value = "";
    option.text = "No Color";
    select.appendChild(option);

    colorPreview.style.backgroundColor = "transparent";
    colorPreview.style.border = "#5D5D5D 1px solid";
    for (const val of window.colors.colors) {
        var option = document.createElement('option');
        option.value = val.settings.name;
        option.text = val.settings.name;
        select.appendChild(option);
    }
}
select.addEventListener('change', function(event) {
    for (const val of window.colors.colors) {
        if (val.settings.name == event.target.value) {

            colorPreview.style.backgroundColor = val.settings.color;
            window.customStyle[".MessengerQuickReply"]["background"] = val.settings.color + " !important";
            window.styleElement.textContent = window.css.of(window.customStyle);
        }
    }
    if (event.target.value == "") {
        colorPreview.style.backgroundColor = "transparent";
        colorPreview.style.border = "#5D5D5D 1px solid";
        window.customStyle['.MessengerQuickReply']['background'] = "transparent !important";
        window.styleElement.textContent = window.css.of(window.customStyle);
    } else {
        colorPreview.style.border = "transparent !important";
    }
});

// Quick Reply Text Color
var selectText = document.getElementById('quick-reply-text-color-selector');
var colorPreviewText = document.getElementById('color-preview-text-quick-reply');
window.updateQuickReplyTextColor = function() {
    selectText.replaceChildren();
    var option = document.createElement('option');
    option.value = "";
    option.text = "No Color";
    selectText.appendChild(option);

    colorPreviewText.style.backgroundColor = "transparent";
    colorPreviewText.style.border = "#5D5D5D 1px solid";
    for (const val of window.colors.colors) {
        var option = document.createElement('option');
        option.value = val.settings.name;
        option.text = val.settings.name;
        selectText.appendChild(option);
    }
}
selectText.addEventListener('change', function(event) {
    for (const val of window.colors.colors) {
        if (val.settings.name == event.target.value) {
            colorPreviewText.style.backgroundColor = val.settings.color;
            window.customStyle[".MessengerQuickReply"]["color"] = val.settings.color + " !important";
            window.styleElement.textContent = window.css.of(window.customStyle);
        }
    }
    if (event.target.value == "") {
        colorPreviewText.style.backgroundColor = "transparent";
        colorPreviewText.style.border = "#5D5D5D 1px solid";
        window.customStyle['.MessengerQuickReply']['color'] = "black !important";
        window.styleElement.textContent = window.css.of(window.customStyle);
    } else {
        colorPreviewText.style.border = "transparent !important";
    }
})

// Quick Reply Font Style
var selectFont = document.getElementById("quick-reply-text-font-selector");
window.updateQuickReplyFonts = function() {
    selectFont.replaceChildren();

    var option = document.createElement('option');
    option.value = "";
    option.text = "No Fonts";
    selectFont.appendChild(option);

    for (const val of window.fonts.fonts) {
        var option = document.createElement('option');
        option.value = val.settings.name;
        option.text = val.settings.name;
        option.setAttribute("data-id", val.id);
        selectFont.appendChild(option);
    }
}
selectFont.addEventListener("change", function(event) {
    for (const val of window.fonts.fonts) {
        if (val.settings.name == event.target.value) {
            selectFont.style.color = val.settings.color;
            selectFont.style.fontFamily = val.settings.fontFamily;
            selectFont.style.fontSize = val.settings.size;

            window.customStyle[".MessengerQuickReply"]["font-family"] = val.settings.fontFamily + " !important";
            window.customStyle[".MessengerQuickReply"]["font-size"] = val.settings.size + " !important";
            window.customStyle[".MessengerQuickReply"]["color"] = val.settings.color + " !important";
            window.styleElement.textContent = window.css.of(window.customStyle);
        }
    }
})

// Corner Radius
var cornerRadiusTopL = document.getElementById('corner-radius-topL-quick-reply');
cornerRadiusTopL.addEventListener('change', function(event) {
    window.customStyle[".MessengerQuickReply"]["border-top-left-radius"] = event.target.value + " !important";
    window.styleElement.textContent = window.css.of(window.customStyle);
})

var cornerRadiusTopR = document.getElementById('corner-radius-topR-quick-reply');
cornerRadiusTopR.addEventListener('change', function(event) {
    window.customStyle[".MessengerQuickReply"]["border-top-right-radius"] = event.target.value + " !important";
    window.styleElement.textContent = window.css.of(window.customStyle);
})

var cornerRadiusBottomR = document.getElementById('corner-radius-bottomR-quick-reply');
cornerRadiusBottomR.addEventListener('change', function(event) {
    window.customStyle[".MessengerQuickReply"]["border-bottom-right-radius"] = event.target.value + " !important";
    window.styleElement.textContent = window.css.of(window.customStyle);
})

var cornerRadiusBottomL = document.getElementById('corner-radius-bottomL-quick-reply');
cornerRadiusBottomL.addEventListener('change', function(event) {
    window.customStyle[".MessengerQuickReply"]["border-bottom-left-radius"] = event.target.value + " !important";
    window.styleElement.textContent = window.css.of(window.customStyle);
})

// Padding
var paddingTop = document.getElementById('padding-top-quick-reply');
paddingTop.addEventListener('change', function(event){
    window.customStyle[".MessengerQuickReply"]["padding-top"] = event.target.value + " !important";
    window.styleElement.textContent = window.css.of(window.customStyle);
})
var paddingBottom = document.getElementById('padding-bottom-quick-reply');
paddingBottom.addEventListener('change', function(event){
    window.customStyle[".MessengerQuickReply"]["padding-bottom"] = event.target.value + " !important";
    window.styleElement.textContent = window.css.of(window.customStyle);
})
var paddingLeft = document.getElementById('padding-left-quick-reply');
paddingLeft.addEventListener('change', function(event){
    window.customStyle[".MessengerQuickReply"]["padding-left"] = event.target.value + " !important";
    window.styleElement.textContent = window.css.of(window.customStyle);
})
var paddingRight = document.getElementById('padding-right-quick-reply');
paddingRight.addEventListener('change', function(event){
    window.customStyle[".MessengerQuickReply"]["padding-right"] = event.target.value + " !important";
    window.styleElement.textContent = window.css.of(window.customStyle);
})

// Margin
var marginTop = document.getElementById('margin-top-quick-reply');
marginTop.addEventListener('change', function(event){
    window.customStyle[".MessengerQuickReply"]["margin-top"] = event.target.value + " !important";
    window.styleElement.textContent = window.css.of(window.customStyle);
})
var marginBottom = document.getElementById('margin-bottom-quick-reply');
marginBottom.addEventListener('change', function(event){
    window.customStyle[".MessengerQuickReply"]["margin-bottom"] = event.target.value + " !important";
    window.styleElement.textContent = window.css.of(window.customStyle);
})
var marginLeft = document.getElementById('margin-left-quick-reply');
marginLeft.addEventListener('change', function(event){
    window.customStyle[".MessengerQuickReply"]["margin-left"] = event.target.value + " !important";
    window.styleElement.textContent = window.css.of(window.customStyle);
})
var marginRight = document.getElementById('margin-right-quick-reply');
marginRight.addEventListener('change', function(event){
    window.customStyle[".MessengerQuickReply"]["margin-right"] = event.target.value + " !important";
    window.styleElement.textContent = window.css.of(window.customStyle);
})

// Border
var borderColor = "black";
var borderWidth = "1px";
var borderString = borderWidth + " solid " + borderColor;

var selectBorderPos = document.getElementById('quick-reply-border-selector');
selectBorderPos.addEventListener('change', function(event) {
    if (event.target.value == "inside") {
        window.customStyle[".MessengerQuickReply"]["box-sizing"] = "border-box !important";
        window.styleElement.textContent = window.css.of(window.customStyle);
    } else {
        window.customStyle[".MessengerQuickReply"]["box-sizing"] = "content-box !important";
        window.styleElement.textContent = window.css.of(window.customStyle);
    }
})

var selectBorder = document.getElementById('quick-reply-border-color-selector');
var colorPreviewBorder = document.getElementById('color-border-preview-quick-reply');
window.updateQuickReplyBorderColor = function() {
    selectBorder.replaceChildren();
    var option = document.createElement('option');
    option.value = "";
    option.text = "No Color";
    selectBorder.appendChild(option);

    colorPreviewBorder.style.backgroundColor = "transparent";
    colorPreviewBorder.style.border = "#5D5D5D 1px solid";

    for (const val of window.colors.colors) {
        var option = document.createElement('option');
        option.value = val.settings.name;
        option.text = val.settings.name;
        selectBorder.appendChild(option);
    }
}
selectBorder.addEventListener('change', function(event) {
    for (const val of window.colors.colors) {
        if (val.settings.name == event.target.value) {
            colorPreviewBorder.style.backgroundColor = val.settings.color;

            borderColor = val.settings.color;
            borderString = borderWidth + " solid " + borderColor;
            window.customStyle[".MessengerQuickReply"]["border"] = borderString + " !important";
            window.styleElement.textContent = window.css.of(window.customStyle);
        }
    }
    if (event.target.value == "") {
        colorPreviewBorder.style.backgroundColor = "transparent";
        colorPreviewBorder.style.border = "#5D5D5D 1px solid";
        window.customStyle['.MessengerQuickReply']['border'] = "transparent !important";
        window.styleElement.textContent = window.css.of(window.customStyle);
    } else {
        colorPreviewBorder.style.border = "transparent";
    }
});

var widthBorder = document.getElementById('width-border-quick-reply');
widthBorder.addEventListener('change', function(event) {
    borderWidth = event.target.value;
    borderString = borderWidth + " solid " + borderColor;
    window.customStyle[".MessengerQuickReply"]["border"] = borderString + " !important";
    window.styleElement.textContent = window.css.of(window.customStyle);
})

// Shadow
var hOffset = "0px";
var vOffset = "0px";
var blurShadow = "0px";
var spreed = "0px";
var shadowColor = "#000";
var shadowPos = "";

var hOffsetElement = document.getElementById("quick-reply-shadow-h-offset");
hOffsetElement.addEventListener("change", function(event) {

    hOffset = event.target.value;
    var shadow = hOffset + " " + vOffset + " " + blurShadow + " " + spreed + " " + shadowColor + " " + shadowPos + " !important";

    window.customStyle[".MessengerQuickReply"]["box-shadow"] = shadow;
    window.styleElement.textContent = window.css.of(window.customStyle);
})

var vOffsetElement = document.getElementById("quick-reply-shadow-v-offset");
vOffsetElement.addEventListener("change", function(event) {

    vOffset = event.target.value;
    var shadow = hOffset + " " + vOffset + " " + blurShadow + " " + spreed + " " + shadowColor + " " + shadowPos + " !important";

    window.customStyle[".MessengerQuickReply"]["box-shadow"] = shadow;
    window.styleElement.textContent = window.css.of(window.customStyle);
})

var blurElement = document.getElementById("quick-reply-shadow-blur");
blurElement.addEventListener("change", function(event) {

    blurShadow = event.target.value;
    var shadow = hOffset + " " + vOffset + " " + blurShadow + " " + spreed + " " + shadowColor + " " + shadowPos + " !important";

    window.customStyle[".MessengerQuickReply"]["box-shadow"] = shadow;
    window.styleElement.textContent = window.css.of(window.customStyle);
})

var spreedElement = document.getElementById("quick-reply-shadow-spreed");
spreedElement.addEventListener("change", function(event) {

    spreed = event.target.value;
    var shadow = hOffset + " " + vOffset + " " + blurShadow + " " + spreed + " " + shadowColor + " " + shadowPos + " !important";

    window.customStyle[".MessengerQuickReply"]["box-shadow"] = shadow;
    window.styleElement.textContent = window.css.of(window.customStyle);
})

var selectShadow = document.getElementById('quick-reply-shadow-color-selector');
var colorPreviewShadow = document.getElementById('color-shadow-preview-color-quick-reply');
window.updateQuickReplyShadowColor = function() {
    selectShadow.replaceChildren();

    var option = document.createElement('option');
    option.value = "";
    option.text = "No Color";
    selectShadow.appendChild(option);

    colorPreviewShadow.style.backgroundColor = "transparent";
    colorPreviewShadow.style.border = "#5D5D5D 1px solid";
    
    for (const val of window.colors.colors) {
        var option = document.createElement('option');
        option.value = val.settings.name;
        option.text = val.settings.name;
        selectShadow.appendChild(option);
    }
}
selectShadow.addEventListener('change', function(event) {
    for (const val of window.colors.colors) {
        if (val.settings.name == event.target.value) {
            colorPreviewShadow.style.backgroundColor = val.settings.color;

            shadowColor = val.settings.color;
            var shadow = hOffset + " " + vOffset + " " + blurShadow + " " + spreed + " " + shadowColor + " " + shadowPos + " !important";
            window.customStyle[".MessengerQuickReply"]["box-shadow"] = shadow;
            window.styleElement.textContent = window.css.of(window.customStyle);
        }
    }
    if (event.target.value == "") {
        colorPreviewShadow.style.backgroundColor = "transparent";
        colorPreviewShadow.style.border = "#5D5D5D 1px solid";
        window.customStyle['.MessengerQuickReply']['box-shadow'] = "none !important";
        window.styleElement.textContent = window.css.of(window.customStyle);
    } else {
        colorPreviewShadow.style.border = "transparent";
    }
});

var shadowPosElement = document.getElementById("quick-reply-shadow-position");
shadowPosElement.addEventListener("change", function(event) {
    if (event.target.value == "inner") {
        shadowPos = "inset";
    } else {
        shadowPos = "";
    }
    var shadow = hOffset + " " + vOffset + " " + blurShadow + " " + spreed + " " + shadowColor + " " + shadowPos + " !important";

    window.customStyle[".MessengerQuickReply"]["box-shadow"] = shadow;
    window.styleElement.textContent = window.css.of(window.customStyle);
})


/*
    QUICK REPLY HOVER
*/

// Quick Reply Hover Background Color
var selectHover = document.getElementById('quick-reply-color-selector-hover');
var colorPreviewHover = document.getElementById('color-preview-quick-reply-hover');
window.updateQuickReplyHoverColor = function() {
    selectHover.replaceChildren();
    var option = document.createElement('option');
    option.value = "";
    option.text = "No Color";
    selectHover.appendChild(option);

    colorPreviewHover.style.backgroundColor = "transparent";
    colorPreviewHover.style.border = "#5D5D5D 1px solid";
        
    for (const val of window.colors.colors) {
        var option = document.createElement('option');
        option.value = val.settings.name;
        option.text = val.settings.name;
        selectHover.appendChild(option);
    }
}
selectHover.addEventListener('change', function(event) {
    for (const val of window.colors.colors) {
        if (val.settings.name == event.target.value) {
            colorPreviewHover.style.backgroundColor = val.settings.color;
            window.customStyle[".MessengerQuickReply:hover"]["background"] = val.settings.color + " !important";
            window.styleElement.textContent = window.css.of(window.customStyle);
        }
    }
    
    if (event.target.value == "") {
        colorPreviewHover.style.backgroundColor = "transparent";
        colorPreviewHover.style.border = "#5D5D5D 1px solid";
        window.customStyle['.MessengerQuickReply:hover']['background'] = "transparent";
        window.styleElement.textContent = window.css.of(window.customStyle);
    } else {
        colorPreviewHover.style.border = "transparent";
    }
});

// Quick Reply Hover Text Color
var selectTextHover = document.getElementById('quick-reply-text-color-selector-hover');
var colorPreviewTextHover = document.getElementById('color-preview-text-quick-reply-hover');
window.updateQuickReplyHoverTextColor = function() {
    selectTextHover.replaceChildren();
    
    var option = document.createElement('option');
    option.value = "";
    option.text = "No Color";
    selectTextHover.appendChild(option);

    colorPreviewTextHover.style.backgroundColor = "transparent";
    colorPreviewTextHover.style.border = "#5D5D5D 1px solid";
        
    for (const val of window.colors.colors) {
        var option = document.createElement('option');
        option.value = val.settings.name;
        option.text = val.settings.name;
        selectTextHover.appendChild(option);
    }
}
selectTextHover.addEventListener('change', function(event) {
    for (const val of window.colors.colors) {
        if (val.settings.name == event.target.value) {
            colorPreviewTextHover.style.backgroundColor = val.settings.color;
            window.customStyle[".MessengerQuickReply:hover"]["color"] = val.settings.color + " !important";
            window.styleElement.textContent = window.css.of(window.customStyle);
        }
    }
    if (event.target.value == "") {
        colorPreviewTextHover.style.backgroundColor = "transparent";
        colorPreviewTextHover.style.border = "#5D5D5D 1px solid";
        window.customStyle['.MessengerQuickReply:hover']['color'] = "transparent";
        window.styleElement.textContent = window.css.of(window.customStyle);
    } else {
        colorPreviewTextHover.style.border = "transparent";
    }
})

// Quick Reply Hover Font Style
var selectFontHover = document.getElementById("quick-reply-hover-text-font-selector");
window.updateQuickReplyFontsHover = function() {
    selectFontHover.replaceChildren();

    var option = document.createElement('option');
    option.value = "";
    option.text = "No Fonts";
    selectFontHover.appendChild(option);

    for (const val of window.fonts.fonts) {
        var option = document.createElement('option');
        option.value = val.settings.name;
        option.text = val.settings.name;
        option.setAttribute("data-id", val.id);
        selectFontHover.appendChild(option);
    }
}
selectFontHover.addEventListener("change", function(event) {
    for (const val of window.fonts.fonts) {
        if (val.settings.name == event.target.value) {
            selectFontHover.style.color = val.settings.color;
            selectFontHover.style.fontFamily = val.settings.fontFamily;
            selectFontHover.style.fontSize = val.settings.size;

            window.customStyle[".MessengerQuickReply:hover"]["font-family"] = val.settings.fontFamily + " !important";
            window.customStyle[".MessengerQuickReply:hover"]["font-size"] = val.settings.size + " !important";
            window.customStyle[".MessengerQuickReply:hover"]["color"] = val.settings.color + " !important";
            window.styleElement.textContent = window.css.of(window.customStyle);
        }
    }
})

// Corner Radius Hover
var cornerRadiusTopLHover = document.getElementById('corner-radius-topL-quick-reply-hover');
cornerRadiusTopLHover.addEventListener('change', function(event) {
    window.customStyle[".MessengerQuickReply:hover"]["border-top-left-radius"] = event.target.value + " !important";
    window.styleElement.textContent = window.css.of(window.customStyle);
})

var cornerRadiusTopRHover = document.getElementById('corner-radius-topR-quick-reply-hover');
cornerRadiusTopRHover.addEventListener('change', function(event) {
    window.customStyle[".MessengerQuickReply:hover"]["border-top-right-radius"] = event.target.value + " !important";
    window.styleElement.textContent = window.css.of(window.customStyle);
})

var cornerRadiusBottomRHover = document.getElementById('corner-radius-bottomR-quick-reply-hover');
cornerRadiusBottomRHover.addEventListener('change', function(event) {
    window.customStyle[".MessengerQuickReply:hover"]["border-bottom-right-radius"] = event.target.value + " !important";
    window.styleElement.textContent = window.css.of(window.customStyle);
})

var cornerRadiusBottomLHover = document.getElementById('corner-radius-bottomL-quick-reply-hover');
cornerRadiusBottomLHover.addEventListener('change', function(event) {
    window.customStyle[".MessengerQuickReply:hover"]["border-bottom-left-radius"] = event.target.value + " !important";
    window.styleElement.textContent = window.css.of(window.customStyle);
})

// Padding Hover
var paddingTopHover = document.getElementById('padding-top-quick-reply-hover');
paddingTopHover.addEventListener('change', function(event){
    window.customStyle[".MessengerQuickReply:hover"]["padding-top"] = event.target.value + " !important";
    window.styleElement.textContent = window.css.of(window.customStyle);
})
var paddingBottomHover = document.getElementById('padding-bottom-quick-reply-hover');
paddingBottomHover.addEventListener('change', function(event){
    window.customStyle[".MessengerQuickReply:hover"]["padding-bottom"] = event.target.value + " !important";
    window.styleElement.textContent = window.css.of(window.customStyle);
})
var paddingLeftHover = document.getElementById('padding-left-quick-reply-hover');
paddingLeftHover.addEventListener('change', function(event){
    window.customStyle[".MessengerQuickReply:hover"]["padding-left"] = event.target.value + " !important";
    window.styleElement.textContent = window.css.of(window.customStyle);
})
var paddingRightHover = document.getElementById('padding-right-quick-reply-hover');
paddingRightHover.addEventListener('change', function(event){
    window.customStyle[".MessengerQuickReply:hover"]["padding-right"] = event.target.value + " !important";
    window.styleElement.textContent = window.css.of(window.customStyle);
})

// Margin Hover
var marginTopHover = document.getElementById('margin-top-quick-reply-hover');
marginTopHover.addEventListener('change', function(event){
    window.customStyle[".MessengerQuickReply:hover"]["margin-top"] = event.target.value + " !important";
    window.styleElement.textContent = window.css.of(window.customStyle);
})
var marginBottomHover = document.getElementById('margin-bottom-quick-reply-hover');
marginBottomHover.addEventListener('change', function(event){
    window.customStyle[".MessengerQuickReply:hover"]["margin-bottom"] = event.target.value + " !important";
    window.styleElement.textContent = window.css.of(window.customStyle);
})
var marginLeftHover = document.getElementById('margin-left-quick-reply-hover');
marginLeftHover.addEventListener('change', function(event){
    window.customStyle[".MessengerQuickReply:hover"]["margin-left"] = event.target.value + " !important";
    window.styleElement.textContent = window.css.of(window.customStyle);
})
var marginRightHover = document.getElementById('margin-right-quick-reply-hover');
marginRightHover.addEventListener('change', function(event){
    window.customStyle[".MessengerQuickReply:hover"]["margin-right"] = event.target.value + " !important";
    window.styleElement.textContent = window.css.of(window.customStyle);
})

// Border Hover
var borderColorHover = "black";
var borderWidthHover = "1px";
var borderStringHover = borderWidthHover + " solid " + borderColorHover;

var selectBorderPosHover = document.getElementById('quick-reply-border-selector-hover');
selectBorderPosHover.addEventListener('change', function(event) {
    if (event.target.value == "inside") {
        window.customStyle[".MessengerQuickReply:hover"]["box-sizing"] = "border-box !important";
        window.styleElement.textContent = window.css.of(window.customStyle);
    } else {
        window.customStyle[".MessengerQuickReply:hover"]["box-sizing"] = "content-box !important";
        window.styleElement.textContent = window.css.of(window.customStyle);
    }
})

var selectBorderHover = document.getElementById('quick-reply-hover-border-color-selector');
var colorPreviewBorderHover = document.getElementById('color-border-preview-quick-reply-hover');
window.updateQuickReplyHoverBorderColor = function() {
    selectBorderHover.replaceChildren();
    var option = document.createElement('option');
    option.value = "";
    option.text = "No Color";
    selectBorderHover.appendChild(option);

    colorPreviewBorderHover.style.backgroundColor = "transparent";
    colorPreviewBorderHover.style.border = "#5D5D5D 1px solid";
    for (const val of window.colors.colors) {
        var option = document.createElement('option');
        option.value = val.settings.name;
        option.text = val.settings.name;
        selectBorderHover.appendChild(option);
    }
}
selectBorderHover.addEventListener('change', function(event) {
    for (const val of window.colors.colors) {
        if (val.settings.name == event.target.value) {
            colorPreviewBorderHover.style.backgroundColor = val.settings.color;

            borderColorHover = val.settings.color;
            borderStringHover = borderWidthHover + " solid " + borderColorHover;
            window.customStyle[".MessengerQuickReply:hover"]["border"] = borderStringHover + " !important";
            window.styleElement.textContent = window.css.of(window.customStyle);
        }
    }
    if (event.target.value == "") {
        colorPreviewBorderHover.style.backgroundColor = "transparent";
        colorPreviewBorderHover.style.border = "#5D5D5D 1px solid";
        window.customStyle['.MessengerQuickReply:hover']['border'] = "transparent";
        window.styleElement.textContent = window.css.of(window.customStyle);
    } else {
        colorPreviewBorderHover.style.border = "transparent";
    }
});

var widthBorderHover = document.getElementById('width-border-quick-reply-hover');
widthBorderHover.addEventListener('change', function(event) {
    borderWidthHover = event.target.value;
    console.log(borderWidthHover);
    borderStringHover = borderWidthHover + " solid " + borderColorHover;
    window.customStyle[".MessengerQuickReply:hover"]["border"] = borderStringHover + " !important";
    window.styleElement.textContent = window.css.of(window.customStyle);
})

// Shadow Hover
var hOffsetHover = "0px";
var vOffsetHover = "0px";
var blurShadowHover = "0px";
var spreedHover = "0px";
var shadowColorHover = "#000";
var shadowPosHover = "";

var hOffsetElementHover = document.getElementById("quick-reply-shadow-h-offset-hover");
hOffsetElementHover.addEventListener("change", function(event) {

    hOffsetHover = event.target.value;
    var shadowHover = hOffsetHover + " " + vOffsetHover + " " + blurShadowHover + " " + spreedHover + " " + shadowColorHover + " " + shadowPosHover + " !important";

    window.customStyle[".MessengerQuickReply:hover"]["box-shadow"] = shadowHover;
    window.styleElement.textContent = window.css.of(window.customStyle);
})

var vOffsetElementHover = document.getElementById("quick-reply-shadow-v-offset-hover");
vOffsetElementHover.addEventListener("change", function(event) {

    vOffsetHover = event.target.value;
    var shadowHover = hOffsetHover + " " + vOffsetHover + " " + blurShadowHover + " " + spreedHover + " " + shadowColorHover + " " + shadowPosHover + " !important";

    window.customStyle[".MessengerQuickReply:hover"]["box-shadow"] = shadowHover;
    window.styleElement.textContent = window.css.of(window.customStyle);
})

var blurElementHover = document.getElementById("quick-reply-shadow-blur-hover");
blurElementHover.addEventListener("change", function(event) {

    blurShadowHover = event.target.value;
    var shadowHover = hOffsetHover + " " + vOffsetHover + " " + blurShadowHover + " " + spreedHover + " " + shadowColorHover + " " + shadowPosHover + " !important";

    window.customStyle[".MessengerQuickReply:hover"]["box-shadow"] = shadowHover;
    window.styleElement.textContent = window.css.of(window.customStyle);
})

var spreedElementHover = document.getElementById("quick-reply-shadow-spreed-hover");
spreedElementHover.addEventListener("change", function(event) {

    spreedHover = event.target.value;
    var shadowHover = hOffsetHover + " " + vOffsetHover + " " + blurShadowHover + " " + spreedHover + " " + shadowColorHover + " " + shadowPosHover + " !important";

    window.customStyle[".MessengerQuickReply:hover"]["box-shadow"] = shadowHover;
    window.styleElement.textContent = window.css.of(window.customStyle);
})

var selectShadowHover = document.getElementById('quick-reply-shadow-color-selector-hover');
var colorPreviewShadowHover = document.getElementById('color-shadow-preview-color-quick-reply-hover');
window.updateQuickReplyShadowColorHover = function() {
    selectShadowHover.replaceChildren();

    var option = document.createElement('option');
    option.value = "";
    option.text = "No Color";
    selectShadowHover.appendChild(option);

    colorPreviewShadowHover.style.backgroundColor = "transparent";
    colorPreviewShadowHover.style.border = "#5D5D5D 1px solid";
    
    for (const val of window.colors.colors) {
        var option = document.createElement('option');
        option.value = val.settings.name;
        option.text = val.settings.name;
        selectShadowHover.appendChild(option);
    }
}
selectShadowHover.addEventListener('change', function(event) {
    for (const val of window.colors.colors) {
        if (val.settings.name == event.target.value) {
            colorPreviewShadowHover.style.backgroundColor = val.settings.color;

            shadowColorHover = val.settings.color;
            var shadowHover = hOffsetHover + " " + vOffsetHover + " " + blurShadowHover + " " + spreedHover + " " + shadowColorHover + " " + shadowPosHover + " !important";
            window.customStyle[".MessengerQuickReply:hover"]["box-shadow"] = shadowHover;
            window.styleElement.textContent = window.css.of(window.customStyle);
        }
    }
    if (event.target.value == "") {
        colorPreviewShadowHover.style.backgroundColor = "transparent";
        colorPreviewShadowHover.style.border = "#5D5D5D 1px solid";
        window.customStyle['.MessengerQuickReply:hover']['box-shadow'] = "none !important";
        window.styleElement.textContent = window.css.of(window.customStyle);
    } else {
        colorPreviewShadowHover.style.border = "transparent";
    }
});

var shadowPosElementHover = document.getElementById("quick-reply-shadow-position-hover");
shadowPosElementHover.addEventListener("change", function(event) {
    if (event.target.value == "inner") {
        shadowPosHover = "inset";
    } else {
        shadowPosHover = "";
    }
    var shadowHover = hOffsetHover + " " + vOffsetHover + " " + blurShadowHover + " " + spreedHover + " " + shadowColorHover + " " + shadowPosHover + " !important";

    window.customStyle[".MessengerQuickReply:hover"]["box-shadow"] = shadowHover;
    window.styleElement.textContent = window.css.of(window.customStyle);
})